<div [formGroup]="form">
  <div
    class="row"
    *ngIf="
      selectedDynamicForm &&
      selectedDynamicForm?.dynamicFormMultipleTypeConfigurations?.length > 0
    "
  >
    <div class="col-md-12 zero-padding">
      <label style="text-align: left" class="col-md-3 col-form-label"
        >Type</label
      >
      <div class="col-md-6">
        <select
          class="form-control"
          (change)="onMultipleTypeSelectionChange($event)"
          formControlName="dynamicFormType"
        >
          <option value="">Select One</option>
          <option
            [title]="item.option"
            style="word-wrap: break-word"
            *ngFor="
              let item of selectedDynamicForm?.dynamicFormMultipleTypeConfigurations
            "
            [value]="item.id"
          >
            {{ item.multipeTypeConfigurationName }}
          </option>
        </select>
      </div>
    </div>
  </div>
  <div
    *ngIf="
      selectedDynamicForm &&
      selectedDynamicFormConfigurations &&
      selectedDynamicFormConfigurations.length > 0
    "
  >
    <div *ngFor="let config of selectedDynamicFormConfigurations">
      <div class="row">
        <div class="col-md-12" *ngIf="config.dynamicFormInputTypeId == 1">
          <client-purchasing-file-upload
            [labelName]="config.label"
            [isDisabled]="false"
            (fileValueChanged)="onFileChange($event, config.tempLabel)"
          >
          </client-purchasing-file-upload>
        </div>

        <div
          class="col-md-12 zero-padding"
          *ngIf="config.dynamicFormInputTypeId == 2"
        >
          <label
            style="text-align: left"
            class="col-md-3 col-form-label"
            [ngClass]="{ required: isRequired(config?.tempLabel || '') }"
            >{{ config.label }}
            <span
              *ngIf="isRequired(config?.tempLabel || '')"
              class="text-danger"
              >*</span
            ></label
          >
          <div class="col-md-6">
            <div class="form-group">
              <input
                type="text"
                [ngClass]="{
                  'has-error': !form.get(config?.tempLabel)?.valid && submitted,
                }"
                class="form-control"
                (input)="handleValidationInput($event, config)"
                [formControlName]="config?.tempLabel ?? ''"
              />
              <label>{{
                form.controls[config.tempLabel]?.value?.length ?? 0
              }}</label>
              <label>/ {{ config.characterValidation }}</label>
            </div>
          </div>
        </div>

        <div
          class="col-md-12 zero-padding"
          *ngIf="config.dynamicFormInputTypeId == 3"
        >
          <label
            style="text-align: left"
            class="col-md-3 col-form-label"
            [ngClass]="{ required: isRequired(config?.tempLabel || '') }"
            >{{ config.label }}
            <span
              *ngIf="isRequired(config?.tempLabel || '')"
              class="text-danger"
              >*</span
            ></label
          >
          <div class="col-md-6">
            <div class="form-group">
              <textarea
                [name]="config?.tempLabel ?? ''"
                (input)="handleValidationInput($event, config)"
                [ngClass]="{
                  'has-error': !form.get(config?.tempLabel)?.valid && submitted,
                }"
                class="form-control"
                rows="5"
                [formControlName]="config?.tempLabel ?? ''"
              >
              </textarea>

              <label>{{
                form.controls[config.tempLabel]?.value?.length ?? 0
              }}</label>
              <label>/ {{ config.characterValidation }}</label>
            </div>
          </div>
        </div>

        <div
          class="col-md-12 zero-padding"
          *ngIf="config.dynamicFormInputTypeId == 4"
        >
          <label
            style="text-align: left"
            class="col-md-3 col-form-label"
            [ngClass]="{ required: isRequired(config?.tempLabel || '') }"
            >{{ config.label }}
            <span
              *ngIf="isRequired(config?.tempLabel || '')"
              class="text-danger"
              >*</span
            ></label
          >
          <div class="col-md-6">
            <select
              class="form-control"
              [ngClass]="{
                'has-error': !form.get(config?.tempLabel)?.valid && submitted,
              }"
              name="{{ config.tempLabel }}"
              [formControlName]="config.tempLabel"
            >
              <option selected [ngValue]="null">Select One</option>
              <option
                [title]="item.option"
                style="word-wrap: break-word"
                *ngFor="let item of sortedOptions(config)"
                [value]="item.id"
              >
                {{ item.option }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-12" *ngIf="config.dynamicFormInputTypeId == 6">
          <h5>
            <u>{{ config.label }} </u>
          </h5>
        </div>
        <!-- Input Type Calender -->
        <div
          class="col-md-12 zero-padding"
          *ngIf="config.dynamicFormInputTypeId == 7"
        >
          <label
            style="text-align: left"
            class="col-md-3 col-form-label"
            [ngClass]="{ required: isRequired(config?.tempLabel || '') }"
            >{{ config.label
            }}<span
              *ngIf="isRequired(config?.tempLabel || '')"
              class="text-danger"
              >*</span
            ></label
          >
          <div class="col-md-6">
            <div class="form-group">
              <input
                type="date"
                [ngClass]="{
                  'has-error': !form.get(config?.tempLabel)?.valid && submitted,
                }"
                autocomplete="off"
                class="form-control"
                id="{{ 'calender-' + config?.tempLabel }}"
                [value]="config?.value | date: 'MM/dd/yyyy'"
                formControlName="{{ config.tempLabel }}"
              />
            </div>
          </div>
        </div>
        <div
          class="col-md-12"
          *ngIf="
            config.furtherInformation != null && config.furtherInformation != ''
          "
        >
          <i>{{ config.furtherInformation }}</i>
        </div>
      </div>
    </div>
  </div>
</div>
